import { render } from "./BlogOpenAiAccountBan.vue?vue&type=template&id=7f72397a"
import script from "./BlogOpenAiAccountBan.vue?vue&type=script&lang=js"
export * from "./BlogOpenAiAccountBan.vue?vue&type=script&lang=js"

import "./BlogOpenAiAccountBan.vue?vue&type=style&index=0&id=7f72397a&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__